import { render, staticRenderFns } from "./TabAccountDetails.vue?vue&type=template&id=25735194&scoped=true&"
import script from "./TabAccountDetails.vue?vue&type=script&lang=js&"
export * from "./TabAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25735194",
  null
  
)

export default component.exports